import {toggleModal} from "./toggleModalActions";

export const getUsersPending = () => {
    return {
        type: 'GET_USERS_PENDING'
    }
};

export const getUsersSuccess = (users, page, pageCount, userCount) => {
    return {
        type: 'GET_USERS_SUCCESS',
        users,
        page,
        pageCount,
        userCount
    }
};

export const getAllUsersSuccess = users => {
    return {
        type: 'GET_ALL_USERS_SUCCESS',
        users
    }
};

export const getCustomUsersSuccess = users => {
    return {
        type: 'GET_ALL_CUSTOM_USERS_SUCCESS',
        users
    }
};

export const getUsersError = error => {
    return {
        type: 'GET_USERS_ERROR',
        error: error
    }
};

export const getUsersForAccessTableSuccess = users => {
    return {
        type: 'GET_USERS_FOR_ACCESS_TABLE_SUCCESS',
        users
    }
}

export const getUATFiltersSuccess = filters => {
    return {
        type: 'GET_USERS_ACCESS_TABLE_FILTER_OPTIONS',
        filters
    }
}

export const setUATFilters = filters => {
    return {
        type: 'SET_USERS_ACCESS_TABLE_FILTERS',
        filters: filters
    }
};

export const selectUATUser = user => {
    return {
        type: 'SELECT_USERS_ACCESS_TABLE_USER',
        uatUser: user
    }
};

export const getLastInvoiceDataSuccess = data => {
    return {
        type: 'GET_LAST_INVOICE_DATA_SUCCESS',
        lastInvoiceData: data
    }
}

export const addInvoiceDataSuccess = () => {
    return {
        type: 'ADD_INVOICE_SUCCESS',
    }
}

export const selectUATInvoice = invoice => {
    return {
        type: 'SELECT_USER_INVOICE',
        selectedInvoice: invoice
    }
};

const getModulesPending = () => ({ type: 'GET_MODULES_PENDING' });
const getModulesError = (error) => ({ type: 'GET_MODULES_ERROR', payload: error });
const getUserModulesSuccess = (data) => ({ type: 'GET_USER_MODULES_SUCCESS', payload: data });

export const getAllUsersForSuperAdmin = (page, search, filter, sorting) => {
    const params = `?number_on_page=${page ? 10 : 9999}`
        + `${page ? `&page=${page}` : ''}`
        + `${search ? `&search=${search}` : ''}`
        + `${filter ? `&filter=NOT_ACTIVE_SENSORS` : ''}`
        + `${sorting ? `&sorting=${sorting}` : ''}`;

    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/all_users_for_super_admin${params}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                page
                    ? dispatch(getUsersSuccess(res.users, res.page, res.pageCount, res.userCount))
                    : dispatch(getAllUsersSuccess(res.users))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    };
}
export const getUsers = (page, search, onlyInvoiceRequiredFilter) => {
    const params = `?number_on_page=${page ? 10 : 9999}${page ? `&page=${page}` : ''}${search ? `&search=${search}` : ''}${onlyInvoiceRequiredFilter ? `&only_invoice_required=${onlyInvoiceRequiredFilter}` : ''}`;

    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/user_list${params}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                page
                    ? dispatch(getUsersSuccess(res.users, res.page, res.pageCount, res.userCount))
                    : dispatch(getAllUsersSuccess(res.users))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    };
};

export const getCustomUsers = (search) => {
    const params = `?search_query=${search}`
    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/user_list_by_name${params}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getCustomUsersSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    };
};

export const getLoggedUser = () => {

    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/current_profile`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch({
                    type: 'GET_LOGGED_USER',
                    user: res
                })
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const selectUser = (user, page) => {
    return {
        type: 'SELECT_USER',
        selected: { user: user, page }
    };
};

export const filterUser = user => {
    return {
        type: 'FILTER_USER',
        user: user
    };
};

export const addUserError = error => {
    return {
        type: 'ADD_USER_ERROR',
        error: error
    }
};

export const addUserSuccess = () => {
    return {
        type: 'ADD_USER_SUCCESS'
    }
};

export const addUser = (superAdmin, userData) => {
    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/add_customer`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(userData)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addUserSuccess())
                    superAdmin ? dispatch(getAllUsersForSuperAdmin(1)) : dispatch(getUsers(1))
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const editUser = (superAdmin,userData, page) => {
    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/update_user_profile`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(userData)
        })
            .then(res => {
                if (res.status === 200) {
                    superAdmin ? dispatch(getAllUsersForSuperAdmin(1)) : dispatch(getUsers(1))
                    dispatch(getLoggedUser());
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteUser = (superAdmin, id, page) => {
    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/delete_user/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    superAdmin ? dispatch(getAllUsersForSuperAdmin(page)) : dispatch(getUsers(page))
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const signUpUser = (name, email, phone, password, distributor, lastName) => {
    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/signup_request`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({name, email, phone, password, distributor, lastName})
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(toggleModal(true, 'signUpComplete'));
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(toggleModal(true, 'signUpFailed'));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const clearUserDeviceIdsList = userId => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/clear_device_ids_list/${userId}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
          .then(res => {
              if (res.status === 200) {
                  dispatch(toggleModal(false, ''));
              } else {
                  dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
              }
          })
          .catch(err => {
              console.log('ERROR', err);
          })
    }
}

export const changePassword = (user, newPassword) => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/custom/users/reset_password_for_user`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({userId: user.id, email: user.email, newPassword})
        })
          .then(res => {
              if (res.status === 200) {
                  dispatch(toggleModal(false, ''));
              } else {
                  dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
              }
          })
          .catch(err => {
              console.log('ERROR', err);
          })
    }
}


export const getUsersForAccessTable = (obj) => {
    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/users_report`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj)
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getUsersForAccessTableSuccess(res.users))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}

export const getUATFilters = () => {

    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/filters_for_users_report`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getUATFiltersSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


export const getLastInvoiceData = (obj) => {
    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/custom/users/get_last_invoice`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj)
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getLastInvoiceDataSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}

export const addInvoiceData = (obj) => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/custom/users/add_invoice`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addInvoiceDataSuccess())
                    dispatch(getLastInvoiceData({agronetUserId: obj.agronetUserId, greenCloudUserId: obj.greenCloudUserId}))
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}

export const getInvoicesHistoryWithNIP = (obj) => {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_API_URL}/custom/users/get_invoice_history`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj)
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`));
                    return { error: true };
                }
            })
            .catch(err => {
                console.log('ERROR', err);
                return { error: true };
            });
    };
};

export const getUserModules = (userId) => {
    const params = userId ? `?userId=${userId}` : '';

    return dispatch => {
        // dispatch(getModulesPending());

        fetch(`${process.env.REACT_APP_API_URL}/modules/moduleListForUser${params}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') || 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(getModulesError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .then(res => {
                if (res) dispatch(getUserModulesSuccess(res));
            })
            .catch(err => {
                console.log('ERROR', err);
                dispatch(getModulesError(err.message));
            });
    };
};

const activateModulePending = () => ({ type: 'ACTIVATE_MODULE_PENDING' });

const activateModuleSuccess = (moduleType) => ({
    type: 'ACTIVATE_MODULE_SUCCESS',
    payload: moduleType
});

const activateModuleError = (error) => ({
    type: 'ACTIVATE_MODULE_ERROR',
    payload: error
});

export const activateUserModule = (userId, moduleType) => {
    const params = `?moduleType=${moduleType}&userId=${userId}`;

    return dispatch => {
        dispatch(activateModulePending());

        fetch(`${process.env.REACT_APP_API_URL}/modules/activateModule${params}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') || 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(activateModuleSuccess(moduleType));
                } else {
                    dispatch(activateModuleError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
                dispatch(activateModuleError(err.message));
            });
    };
};

export const deactivateUserModule = (userId, moduleType) => {
    const params = `?moduleType=${moduleType}&userId=${userId}`;

    return dispatch => {
        dispatch({ type: 'DEACTIVATE_MODULE_PENDING' });

        fetch(`${process.env.REACT_APP_API_URL}/modules/deactivateModule${params}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') || 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch({ type: 'DEACTIVATE_MODULE_SUCCESS', payload: moduleType });
                } else {
                    dispatch({ type: 'DEACTIVATE_MODULE_ERROR', payload: `Error: ${res.status} ${res.statusText}` });
                }
            })
            .catch(err => {
                console.error('ERROR', err);
                dispatch({ type: 'DEACTIVATE_MODULE_ERROR', payload: err.message });
            });
    };
};
